module.exports = __webpack_public_path__ + "img/copy.16602d15.svg";